import { Separator } from "../Separator";
import { Text } from "../Text";

export const getAlertText = (price?: number) => {
  return (
    <>
      <Text
        display="block"
        size={{
          "@onlyMobile": "s",
          "@fromTablet": "m",
        }}
      >
        W pakiecie taniej - poinformuj klienta, że pierwszy nju subskrypcja
        będzie tańszy o {price} zł miesięcznie, jeśli klient będzie miał aktywny
        nju światłowód.
      </Text>
      <Text
        display="block"
        size={{
          "@onlyMobile": "s",
          "@fromTablet": "m",
        }}
      >
        Rabat będzie naliczany co miesiąc w momencie płatności za nju
        subskrypcja.
      </Text>
    </>
  );
};

export const getAlertEsimText = (price?: number) => {
  return (
    <>
      <Text
        display="block"
        size={{
          "@onlyMobile": "s",
          "@fromTablet": "m",
        }}
        weight="bold"
      >
        Poinformuj klienta, że:
      </Text>
      <ul className="pl-4 list-disc">
        <li>
          w pakiecie taniej - poinformuj klienta, że pierwszy nju subskrypcja
          będzie{" "}
          <span className="font-bold">tańszy o {price} zł miesięcznie</span>,
          jeśli klient będzie miał aktywny nju światłowód.
        </li>
      </ul>
      <ul className="pl-4 list-disc">
        <li>
          mamy nowość w nju: <span className="font-bold">eSIM</span> - od teraz
          klient może mieć wirtualną kartę SIM, a zamówi ją za darmo przez apkę
          lub na koncie klienta na nju.pl.
        </li>
      </ul>
      <Separator tone="invisible" />
      <Text
        display="block"
        size={{
          "@onlyMobile": "s",
          "@fromTablet": "m",
        }}
      >
        Sprawdź w szczegółach oferty,{" "}
        <span className="font-bold">czy dostępna jest sekcja bonusy</span> -
        jeśli tak, poinformuj klienta o szczegółach.
      </Text>
    </>
  );
};

export const alertPaymentText = (
  <Text
    display="block"
    size={{
      "@onlyMobile": "s",
      "@fromTablet": "m",
    }}
  >
    Poinformuj klienta, że kupuje usługę nju światłowód, za którą będzie płacić
    za każdy miesiąc z góry. Pierwsza płatność (do wyboru płatność online lub
    BLIK) zostanie zrealizowana dopiero po instalacji usługi w lokalu klienta.
    Do momentu zapłaty za usługę nie będzie możliwości korzystania z internetu.
    <Separator tone="invisible" />
    Po zakupie klient będzie mógł zmienić metodę płatności (płatność online,
    BLIK lub płatność kartą). Dla płatności online i BLIK klient może od razu
    dodać większą kwotę na poczet przyszłych opłat i przez dłuższy czas nie
    martwić się o płatności.
  </Text>
);
